import { createAction, props } from '@ngrx/store';
import { UserItem } from '../../user.model';
import {DashboardItem} from '../../dashboard.model';

export const loadDashboardStart = createAction('LANDINGPAGE::LOAD_DASHBOARD_START', props<{userId: number}>());
export const loadDashboardSucceeded = createAction(
    'LANDINGPAGE::LOAD_DASHBOARD_SUCCEEDED',
    props<{ dashboard: DashboardItem[] }>(),
);
export const loadDashboardFailed = createAction('LANDINGPAGE::LOAD_DASHBOARD_FAILED', props<{ error: Error }>());
